var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-content',{staticClass:"filter-empty-message-list-item"},[_vm._v("\n        "+_vm._s(_vm.t_no_data_to_show)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }